<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters style="background-color: #f9f9f9;">
      <QTextArea v-model="item.CustomerComment" :disabled="disabled"
        :label="$t('servicesystem.common_objects.machine.edit.customer_comment')"
        :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampJobDescription"
        :externaledit="item.New || editMode" :backgroundcolor="'#f9f9f9'" @FocusState="handleFocus"
        :rules="[requiredRule]" class="mx-3">
      </QTextArea>
    </v-row>

    <v-divider />

    <v-row class="ma-0 my-n1">
      <v-col v-if="!isNew" :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
        <QAutoComplete v-model="item.JobTypeId" :label="$t('servicesystem.common_objects.job.type')" :list="typeList"
          :textkey="'Name'" :valuekey="'Id'" :rules="[requiredRule]" :externaledit="item.New || editMode"
          @FocusState="handleFocus">
        </QAutoComplete>
      </v-col>
      <v-col :cols="isPcBool ? (!isNew ? 4 : 6) : (isPhoneBool ? 12 : 6)">
        <SupplierFailureCodeSelect v-model="item.SupplierFailureCodeId" allowCreate
          :filter="{ SupplierIdList: item.SupplierId ? [item.SupplierId] : undefined }" clearable hideIcon disableAttach
          :disabled="!item.SupplierId" :externaledit="item.New || editMode" @FocusState="handleFocus">
        </SupplierFailureCodeSelect>
      </v-col>
      <v-col :cols="0">
        <RepairCodeSelect v-model="item.RepairCodes" allowCreate returnobject clearable multiple hideIcon disableAttach
          :externaledit="item.New || editMode" @FocusState="handleFocus">
        </RepairCodeSelect>
      </v-col>
    </v-row>

    <v-row class="ma-0 my-n1">
      <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
        <RepairPlaceSelect v-model="item.RepairPlaceId" allowCreate clearable hideIcon
          :externaledit="item.New || editMode" @FocusState="handleFocus">
        </RepairPlaceSelect>
      </v-col>
      <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
        <WarrantyTypeSelect v-model="item.WarrentyTypeId" allowCreate clearable hideIcon
          :externaledit="item.New || editMode" @FocusState="handleFocus">
        </WarrantyTypeSelect>
      </v-col>
      <v-col :cols="isPcBool ? 4 : (isPhoneBool ? 12 : 6)">
        <QAutoComplete v-model="item.JobCategoryId" :label="$t('servicesystem.common_objects.job.job_category')"
          :list="jobCategoryList" :textkey="'Name'" :valuekey="'Id'" clearable :externaledit="item.New || editMode"
          @FocusState="handleFocus">
        </QAutoComplete>
      </v-col>
    </v-row>

    <v-divider v-if="!isNew && !item.New" />

    <v-row no-gutters>
      <v-col :cols="(item.InvoiceComment || item.TechnicianComment) ? 12 : 6" style="background-color: #fff0f6;">
        <QTextArea v-if="!isNew && !item.New" v-model="item.TechnicianComment"
          :label="$t('servicesystem.common_objects.machine.edit.technician_comment')"
          :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampTechnicianComment" :backgroundcolor="'#fff0f6'"
          :singleline="!item.TechnicianComment"
          :placeholder="!item.TechnicianComment ? $t('servicesystem.common_objects.machine.edit.technician_comment') : undefined"
          :externaledit="editMode" @FocusState="handleFocus" class="mx-3">
        </QTextArea>
      </v-col>
      <v-col :cols="(item.InvoiceComment || item.TechnicianComment) ? 12 : 6" style="background-color: #edfffd;">
        <QTextArea v-if="!isNew && !item.New" v-model="item.InvoiceComment"
          :label="$t('servicesystem.common_objects.machine.edit.invoice_comment')" :backgroundcolor="'#edfffd'"
          :singleline="!item.InvoiceComment"
          :placeholder="!item.InvoiceComment ? $t('servicesystem.common_objects.machine.edit.invoice_comment') : undefined"
          :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampInvoiceComment" :externaledit="editMode"
          @FocusState="handleFocus" class="mx-3">
        </QTextArea>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import RepairCodeSelect from "@/components/Inputs/EntityDropdowns/RepairCodeSelect2.vue";
import RepairPlaceSelect from "@/components/Inputs/EntityDropdowns/RepairPlaceSelect2.vue";
import SupplierFailureCodeSelect from "@/components/Inputs/EntityDropdowns/SupplierFailureCodeSelect2.vue";
import WarrantyTypeSelect from "@/components/Inputs/EntityDropdowns/WarrantyTypeSelect2.vue";

export default {
  name: "MachineJobCardContent",
  props: {
    isNew: Boolean,
    item: Object,
    editMode: Boolean,
    handleFocus: {
      type: Function,
      default: () => { },
    },
    disabled: Boolean,
  },
  components: {
    RepairCodeSelect,
    RepairPlaceSelect,
    SupplierFailureCodeSelect,
    WarrantyTypeSelect,
  },
  mixins: [],

  data() {
    return {
    };
  },

  methods: {},

  computed: {
    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    jobCategoryList() {
      return this.$store.getters["LookUpStore/JobCategoryList"];
    },

    typeList() {
      var list = this.$store.getters["LookUpStore/JobTypeList"];
      return list && list.length ? list : [];
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>